import { hot } from 'react-hot-loader';
import { Switch, Route, useLocation } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useEffect } from 'react';

import NotificationsSystem, {
  NotificationsProvider,
  atalhoTheme,
  useNotifications,
  setUpNotifications,
} from 'reapop';

import ErrorPageLayout from './modules/errorPage/layouts/ErrorPage.layout';
import getQuery from './api/rest';
import RegistrationCTA from './modules/registrationPage/ctas/RegistrationPage.cta';
import EventsPageLayout from './modules/eventsPage/layouts/EventsPage.layout';
import CompanyDetailsLayout from './modules/companyDetailsPage/layouts/CompanyDetailsPage.layout';
import RegistrationPageLayout from './modules/registrationPage/layouts/RegistrationPage.layout';
import Header from './modules/common/components/Header';
import Footer from './modules/common/components/Footer';

import '@snaphunt/snaphunt-theme/dist/semantic.snaphunt.css';

// run this function when your application starts before creating any notifications
setUpNotifications({
  defaultProps: {
    position: 'top-right',
    dismissible: true,
    dismissAfter: 5000,
  },
});

// Creates a new query client
// provide the default query function to your app with defaultOptions
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: getQuery,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 30000,
    },
  },
});

const ToastHolder = () => {
  // Retrieve the notifications to display, and the function used to dismiss a notification.
  const { notifications, dismissNotification } = useNotifications();
  return (
    <div>
      <NotificationsSystem
        // Pass the notifications you want Reapop to display.
        notifications={notifications}
        // Pass the function used to dismiss a notification.
        dismissNotification={id => dismissNotification(id)}
        // Pass a builtIn theme or a custom theme.
        theme={atalhoTheme}
      />
    </div>
  );
};

const App = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div
      css={{
        maxWidth: '100%',
        overflowX: 'hidden',
        '-webkit-filter': 'saturate(100%)',
      }}
    >
      <QueryClientProvider client={queryClient}>
        <NotificationsProvider>
          <Header />
          <RegistrationCTA />
          <Switch>
            <Route exact component={EventsPageLayout} path="/events" />
            <Route
              exact
              component={CompanyDetailsLayout}
              path="/company/:companyName"
            />
            <Route exact component={RegistrationPageLayout} path="/" />
            <Route component={ErrorPageLayout} />
          </Switch>
          <Footer />
          <ToastHolder />
        </NotificationsProvider>
      </QueryClientProvider>
    </div>
  );
};

export default hot(module)(App);
